export const DELETE_BASKET_ENTRY = 'DeleteBasketEntry';

export const deleteBasketEntry = (payload: { id: string }) => ({
    type: DELETE_BASKET_ENTRY,
    payload,
})